import {defineMessages} from 'react-intl'

export default defineMessages({
    quoteAccepted: {
        id: 'containers.ProjectPage.components.ProjectPage.quoteAccepted',
        defaultMessage: 'Selected voices and services'
    },
    quoteNotAccepted: {
        id: 'containers.ProjectPage.components.ProjectPage.quoteNotAccepted',
        defaultMessage: 'Review and select services and voice over rates, and proceed by accepting quote'
    },
    Recommended: {
        id: 'containers.ProjectPage.components.ProjectPage.Recommended',
        defaultMessage: 'Recommended'
    },
    downloadQuote: {
        id: 'containers.ProjectPage.components.ProjectPage.downloadQuote',
        defaultMessage: 'Download quote'
    },
    loading: {
        id: 'containers.ProjectPage.components.ProjectPage.loading',
        defaultMessage: 'Loading'
    },
})
